import React, { memo } from "react";
import { ReactComponent as SelectedIcon } from "../../../../assets/images/SelectedIcon.svg";

import GetAssistanceButton from "../../../../modules/RefactoredWizard/components/WizardInstruction/components/GetAssistanceButton";

import { useShopifyApp } from "../../../../hooks/useShopifyApp";

import { ButtonWrapper, Container, StyledLink, Text, Wrapper } from "./styles";

const FooterNotification = ({ faqLink }) => {
  const isShopifyApp = useShopifyApp();

  return (
    <Container>
      {faqLink && (
        <Wrapper>
          <SelectedIcon />
          <Text>
            Find out
            <StyledLink href={faqLink} target="_blank">
              more information
            </StyledLink>
            about this error
          </Text>
        </Wrapper>
      )}

      <ButtonWrapper $isShopifyApp={isShopifyApp}>
        <GetAssistanceButton title="Start Chat To Get Help" />
      </ButtonWrapper>
    </Container>
  );
};

export default memo(FooterNotification);
